// =============================================================================
// reducers/incidentReducer.js
//
// Estado do dominio Incidents.
// O filtrado e CLIENT-SIDE — o backend devolve todos os incidentes uma vez
// por refresh e os filtros sao aplicados em useMemo dentro do hook.
// =============================================================================
import {
	INCIDENTS_FETCH_REQUEST, INCIDENTS_FETCH_SUCCESS, INCIDENTS_FETCH_FAILURE,
	INCIDENT_HISTORY_FETCH_REQUEST, INCIDENT_HISTORY_FETCH_SUCCESS, INCIDENT_HISTORY_FETCH_FAILURE,
	INCIDENT_SELECT, INCIDENT_FILTER_CHANGE, INCIDENT_FILTER_RESET,
} from '../constants/kpiConstants';

const DEFAULT_FILTERS = {
	status:         'Open',     // 'all' | 'Open' | 'Closed'
	tech:           'all',
	severity:       'all',
	vendor:         'all',
	kpiName:        'all',
	siteId:         '',
	cellId:         '',
	durationBucket: 'all',      // 'all' | 'lt1' | '1to3' | '4to7' | 'gt7'
};

const initialState = {
	items:          [],
	loading:        false,
	error:          null,

	selected:       null,
	history:        [],
	historyLoading: false,
	historyError:   null,

	filters: Object.assign({}, DEFAULT_FILTERS),
};

export default function incidentReducer(state, action) {
	if (state === undefined) state = initialState;

	switch (action.type) {
		case INCIDENTS_FETCH_REQUEST:
			return Object.assign({}, state, { loading: true, error: null });
		case INCIDENTS_FETCH_SUCCESS:
			return Object.assign({}, state, { loading: false, items: action.payload, error: null });
		case INCIDENTS_FETCH_FAILURE:
			return Object.assign({}, state, { loading: false, error: action.payload });

		case INCIDENT_HISTORY_FETCH_REQUEST:
			return Object.assign({}, state, { historyLoading: true, historyError: null, history: [] });
		case INCIDENT_HISTORY_FETCH_SUCCESS:
			return Object.assign({}, state, { historyLoading: false, history: action.payload });
		case INCIDENT_HISTORY_FETCH_FAILURE:
			return Object.assign({}, state, { historyLoading: false, historyError: action.payload });

		case INCIDENT_SELECT:
			return Object.assign({}, state, { selected: action.payload, history: [] });

		case INCIDENT_FILTER_CHANGE:
			return Object.assign({}, state, {
				filters: Object.assign({}, state.filters, action.payload),
			});

		case INCIDENT_FILTER_RESET:
			return Object.assign({}, state, {
				filters: Object.assign({}, DEFAULT_FILTERS),
			});

		default:
			return state;
	}
}
